import { GET_ERRORS, DELETE_USER, UPDATE_USER, CREATE_USER, UPDATE_USER_CONFIGURATION } from "../../../../actions/types";
import { getUsers, addUser, updateUser, deleteUser } from "../../../../actions/UserActions";
import { updateUserConfiguration } from "../../../../actions/UserConfigurationActions";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import SocialReasons from "../AddressManagementPerUser/SocialReasons";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Edit, Info, Build, Visibility } from "@material-ui/icons";
import { getCenters } from "../../../../actions/CenterActions";
import UserConfigurationModal from "./UserConfigurationModal";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import UserDetailComponent from "./UserDetailComponent";
import BootstrapTable from "react-bootstrap-table-next";
import DialogTitle from "@material-ui/core/DialogTitle";
import LoadingOverlay from "react-loading-overlay";
import Snackbar from "@material-ui/core/Snackbar";
import { TextField } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import docs from "../../../../config/docs";
import { Col, Row } from "react-bootstrap";
import React, { Component } from "react";
import { IconButton } from "material-ui";
import { connect } from "react-redux";
import "./UserListComponent.scss";
import "../MainContent.scss";
import "../Modal/Modal.scss";

const URL        = docs.docsUsers;
const ROLES_B2B  = ["B2B"];
const ROLES_PREV = ["PREV"];
const ROLES_ALL  = ["B2B", "PREV"];

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class UserListComponent extends Component {
	///---------------------------------------INIT-------------------------------------

	state = {
		userConfigurationModalIsVisible: false,
		showDeactivateDialog:            false,
		addModalIsVisible:               false,
		showSocialReasons:               false,
		showSnackBar:                    false,
		activeLoader:                    true,
		severitySnackBar:                'success',
		textSnackBar:                    '',
		modalType:                       'NORMAL',
		userType:                        'TODOS',
		search:                          '',
		selectedId:                      0,
		skip:                            1,
		users:                           [],
		selectedUser:                    null
	};

	constructor(props) {
		super(props);
		this.handleCancelUserConfiguration = this.handleCancelUserConfiguration.bind(this);
		this.handleUpdateUserConfiguration = this.handleUpdateUserConfiguration.bind(this);
		this.handleCloseDeactivateDialog   = this.handleCloseDeactivateDialog.bind(this);
		this.openUserConfiguration         = this.openUserConfiguration.bind(this);
		this.onPressDelete                 = this.onPressDelete.bind(this);
		this.handleSubmit                  = this.handleSubmit.bind(this);
		this.handleCancel                  = this.handleCancel.bind(this);
		this.handleUpdate                  = this.handleUpdate.bind(this);
		this.onDeactivate                  = this.onDeactivate.bind(this);
		this.handleClose                   = this.handleClose.bind(this);
		this.openModal                     = this.openModal.bind(this);
		this.onChange                      = this.onChange.bind(this);
		this.onSearch                      = this.onSearch.bind(this);
	}

	componentDidMount() {
		this.setState({
			activeLoader: true,
		});
		this.props.getUsers(this.state.skip, ROLES_ALL, null);
		this.props.getCenters();
	}

	componentDidUpdate(prevProps) {
		if (this.props.users !== this.state.users) {
			this.setState({
				users:        this.props.users,
				activeLoader: false,
			});
		} else if (this.props.actionType === DELETE_USER && prevProps.actionType !== DELETE_USER) {
			this.props.getUsers(this.state.skip, ROLES_ALL, null);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Usuario desactivada exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === UPDATE_USER && prevProps.actionType !== UPDATE_USER) {
			this.props.getUsers(this.state.skip, ROLES_ALL, null);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Usuario actualizado exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === CREATE_USER && prevProps.actionType !== CREATE_USER) {

			this.props.getUsers(this.state.skip, ROLES_ALL, null);
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Usuario creado exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionTypeUserConfiguration === UPDATE_USER_CONFIGURATION && prevProps.actionTypeUserConfiguration !== UPDATE_USER_CONFIGURATION) {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Configuración actualizada.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: "error",
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		this.setState({
			showDeactivateDialog: false,
		});
	};

	handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		this.setState({
			showSnackBar: false,
		});
	};

	openModal = () => {
		this.setState({
			addModalIsVisible: true,
			modalType: "NORMAL",
		});
	};

	handleUpdate(id, nombre, branch, email, userType) {
		
		let roles = [];

		switch (userType) {
			case "CLIENTE":
				roles = ROLES_B2B;
				break;

			case "PREVENTISTA":
				roles = ROLES_PREV;
				break;
			default:
				roles = [];
				break;
		}

		this.setState({
			activeLoader: true,
			addModalIsVisible: false,
		});

		this.props.updateUser(
			id,
			nombre,
			branch ? branch.innerBranchId : null,
			email,
			roles
		);
	}

	handleSubmit(nombre, branch, email, sendSMS, phoneNumber, userType) {
		switch (userType) {
			case "PREVENTISTA":
				this.props.addUser(
					nombre,
					branch.innerBranchId,
					ROLES_PREV,
					email,
					sendSMS,
					phoneNumber
				);
				break;
			case "CLIENTE":
				this.props.addUser(
					nombre,
					branch.innerBranchId,
					ROLES_B2B,
					email,
					sendSMS,
					phoneNumber
				);
				break;
			default:
				console.error(userType);
				break;
		}

		this.setState({
			activeLoader:      true,
			addModalIsVisible: false,
		});
	}

	handleUpdateUserConfiguration (userConfiguration) {
		this.props.updateUserConfiguration(userConfiguration);
		this.setState({
			activeLoader:                    true,
			userConfigurationModalIsVisible: false,
			userData:                        null
		})
	}

	handleCancel() {
		this.setState({
			addModalIsVisible:               false,
			userConfigurationModalIsVisible: false,
			userData:                        null,
		});
	}

	handleCancelUserConfiguration() {
		this.setState({
			userConfigurationModalIsVisible: false,
			userData:                        null
		})
	}

	onPressDelete(id) {
		this.setState({
			showDeactivateDialog: true,
			addModalIsVisible:    false,
			selectedId:           id,
		});
	}

	onDeactivate() {
		this.setState({
			activeLoader:         true,
			showDeactivateDialog: false,
		});
		this.props.deleteUser(this.state.selectedId);
	}

	onChange(e) {
		e.persist();
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	onSearch() {
		if (this.state.search.length > 0) {
			this.setState(
				{
					skip: 1,
				},
				() => {
					let search = "&search=" + this.state.search;
					this.setState({
						activeLoader: true,
					});
					this.props.getUsers(this.state.skip, ROLES_ALL, search);
				}
			);
		}
	}

	openUserConfiguration = () => {
		this.setState({
			userConfigurationModalComponentIsVisible: true
		})
	}

	redirectTo() {
		const newWindow = window.open(URL, "_blank", "noopener,noreferrer");
		if (newWindow) newWindow.opener = null;
	}

	linkActions = (cell, row, rowIndex, formatExtraData) => {
		return ([
			<Row key={rowIndex}>
				<Col xs={12} md={12} sm={12} lg={12}>
					<IconButton size="small" style={{color:"orange"}}>
						<Edit
							key={row._id}
							onClick={() => {
								this.setState({
									modalType: "UPDATE",
									userData: row,
									addModalIsVisible: !this.state.addModalIsVisible,
									defaultInnerBranchId: row.innerBranchId
								})
							}}
						>
							Editar
						</Edit>
					</IconButton>
					<IconButton size="small"  style={{color:"blue"}}>
						<Build 
							key={row._id + '_build'}
							onClick={() => {
								this.setState({
									userData: row,
									userConfigurationModalIsVisible: !this.state.userConfigurationModalIsVisible,
								});
							}}
						/>
					</IconButton>
					<IconButton size="small"  style={{color:"brown"}}>
						<Visibility
							key={row._id + '_view'}
							onClick={() => {
								this.setState({
									showSocialReasons: true,
									selectedUser:      row
								});
							}}
							/>
					</IconButton>
				</Col>
			</Row>
		]);
	};

	pagination() {
		this.setState({
			activeLoader: true,
		});

		let search = "&search=" + this.state.search;
		this.props.getUsers(this.state.skip, ROLES_ALL, search);
	}

	onPressReturnUD = () => {
		this.setState({
			showSocialReasons: false,
			selectedUser:      null
		});
	};

	///---------------------------------------VIEW-------------------------------------

	render() {
		const customOptions = {
			noDataText:
				'<div className="color-red">No hay datos disponibles para su consulta.</div>',
		};
		const columns = [
			{
				dataField: "nombre",
				text: "Nombre",
				formatter: (cell) => {
					return cell.toUpperCase();
				},
			},
			{
				dataField: "email",
				text: "Email",
				classes: 'table-cell'
			},
			{
				dataField: "roles",
				text: "Tipo de usuario",
				formatter: (cell) => {
					if (cell) {
						if (cell.length > 2) return "------";
						else if (cell.includes("B2B")) return "CLIENTE";
						else if (cell.includes("PREV")) return "PREVENTISTA";
					}
				},
			},
			{
				dataField: "centroFarmazon.nombre",
				text: "Centro Farmazon",
				formatter: (cell) => {
					if (cell) return cell.toUpperCase();
				},
			},
			{
				dataField: "is_active",
				text: "Estatus",
				formatter: (cell) => {
					return cell === true ? "Activo" : "Inactivo";
				},
			},
			{
				dataField: "actions",
				text:      "Acciones",
				formatter: this.linkActions,
			}
		];

		const total      = this.props.total;
		const totalPages = Math.ceil(total / 10);

		return (
			<div className="main-content">
				{this.state.showSocialReasons ? (
					<div>
						<SocialReasons userData={this.state.selectedUser} onPressReturnUD={this.onPressReturnUD} />
					</div>
    			) : (
					<>
						<div className="malls-category-headers">
							Gestión de usuarios.
							<IconButton size="small">
								<Info onClick={() => this.redirectTo()} />
							</IconButton>
						</div>
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						<div className="toolbar100 space">
							<TextField
								style={{ height: "7%", width: "30%" }}
								id="input-search"
								label="Buscar."
								name="search"
								inputProps={{ style: { fontSize: "1.1rem" } }}
								InputLabelProps={{ style: { fontSize: "0.6rem" } }}
								onChange={this.onChange}
								value={this.state.search}
								size="medium"
							/>
							<button
								className="edit-buttonOK"
								onClick={this.onSearch}
								style={{
									width: "10%",
									marginTop: "1%",
									marginRight: "3.5%",
									fontSize: "0.7rem",
								}}
							>
								Buscar
							</button>
							
							<button
								onClick={this.openModal}
								className="buttonAdd"
								style={{
									width: "20%",
									marginTop: "1%",
									marginRight: "3.5%",
									fontSize: "0.8rem",
								}}
							>
								Agregar
							</button>
						</div>
						<div className="user-category-wrapper">
							{
								<div>
									<BootstrapTable
										keyField='_id'
										striped
										hover
										condensed
										data={this.state.users}
										headerWrapperClasses="title-table"
										options={customOptions}
										columns={columns}
									/>
								</div>
							}
							<br></br>
							<div className="toolbar100 end">
								<button
									className={
										this.state.skip !== 1
											? "modalButtonPager"
											: "modalButtonPager disabled"
									}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState(
											{
												skip: this.state.skip - 1,
											},
											() => {
												this.pagination();
											}
										);
									}}
									disabled={this.state.skip === 1 ? true : false}
								>
									« Anterior
								</button>

								<button
									className={
										this.state.skip < totalPages
											? "modalButtonPager"
											: "modalButtonPager disabled"
									}
									onMouseDown={(e) => {
										e.preventDefault();
										this.setState(
											{
												skip: this.state.skip + 1,
											},
											() => {
												this.pagination();
											}
										);
									}}
									disabled={this.state.skip < totalPages ? false : true}
								>
									Siguiente »
								</button>
							</div>
						</div>
						<UserDetailComponent
							isVisible={this.state.addModalIsVisible}
							handleSubmit={this.handleSubmit}
							handleCancel={this.handleCancel}
							centros={this.props.centros.centros}
							error={this.props.users.error}
							type={this.state.modalType}
							userData={this.state.userData}
							defaultInnerBranchId={this.state.defaultInnerBranchId}
							handleUpdate={this.handleUpdate}
							onDelete={this.onPressDelete}
							auth={this.props.auth}
						/>
						<UserConfigurationModal
							isVisible={this.state.userConfigurationModalIsVisible}
							userData={this.state.userData}
							handleCancel={this.handleCancelUserConfiguration}
							handleUpdate={this.handleUpdateUserConfiguration}
						></UserConfigurationModal>
						{
							<LoadingOverlay
								active={this.state.activeLoader}
								isVisible={this.state.activeLoader}
								spinner
								text="Esto puede tardar unos minutos"
								styles={{
									wrapper: {
										width: this.state.activeLoader ? "100%" : "0%",
										height: this.state.activeLoader ? "100%" : "0%",
									},
									overlay: (base) => ({
										...base,
										background: "rgba(10, 10, 10, 0.7)",
									}),
								}}
							></LoadingOverlay>
						}
						{
							<Dialog
								open={this.state.showDeactivateDialog}
								onClose={this.handleCloseDeactivateDialog}
								aria-labelledby="alert-dialog-title"
								aria-describedby="alert-dialog-description"
							>
								<DialogTitle id="alert-dialog-title">
									{"Desactivar usuario"}
								</DialogTitle>
								<DialogContent>
									<DialogContentText id="alert-dialog-description">
										¿Seguro que deseas desactivar usuario?
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button
										onClick={this.handleCloseDeactivateDialog}
										color="secondary"
									>
										Cancelar
									</Button>
									<Button onClick={this.onDeactivate} color="primary" autoFocus>
										Desactivar
									</Button>
								</DialogActions>
							</Dialog>
						}
						{
							<Snackbar
								open={this.state.showSnackBar}
								autoHideDuration={6000}
								onClose={this.handleClose}
							>
								<Alert
									onClose={this.handleClose}
									severity={this.state.severitySnackBar}
								>
									{this.state.textSnackBar}
								</Alert>
							</Snackbar>
						}
					</>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	actionTypeUserConfiguration: state.user_configuration_reducer.actionType,
	actionType:                  state.user_reducer.actionType,
	centros:                     state.center_reducer,
	users:                       state.user_reducer.clients,
	total:                       state.user_reducer.total,
	error:                       state.user_reducer.error,
	auth:                        state.auth,
});

export default connect(mapStateToProps, {
	updateUserConfiguration,
	getCenters,
	updateUser,
	deleteUser,
	getUsers,
	addUser,
})(UserListComponent);
